/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import {
    renderDefaultError,
    renderDefaultLoading,
    SmartComponentProps
  } from '@exo/frontend-common-utils';
  
  import { useCurrencyConvertor } from '../../hooks/useCurrencyConvertor';
  
  export const CurrencyConvertorContainer = ({
    render,
    renderLoading = renderDefaultLoading,
    renderError = renderDefaultError
  }: Props) => {
    const { loading, data, error } = useCurrencyConvertor();
  
    if (loading || !data) return renderLoading();
    if (error) return renderError(error);
  
    const CurCurrencyRatesData = data;
    return render(CurCurrencyRatesData);
  };
  
  type Props = SmartComponentProps<{
    render: (props: any[]) => JSX.Element;
    CurCurrencyRates?: any;
  }>;
